'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const components_display_VisuallyHidden_VisuallyHidden = require('../VisuallyHidden/VisuallyHidden.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_1r8l6_1";
const spin = "_spin_1r8l6_1";
const styles = {
	root: root,
	spin: spin
};

const Spinner = ({ "aria-label": ariaLabel = "Loading", color = "dark", size = "small" }) => {
  return React__default.default.createElement(
    "div",
    { className: styles.root, "data-testid": "spinner", role: "status", "data-zds": true, "data-color": color, "data-size": size },
    React__default.default.createElement(components_display_VisuallyHidden_VisuallyHidden.VisuallyHidden, null, ariaLabel)
  );
};

exports.Spinner = Spinner;
//# sourceMappingURL=Spinner.cjs.js.map
